import { SITE_CONFIG } from '../../config/site-config';
import { mailto, routeHref } from '../../lib/links';

export const legalEmailLink = (): string => `<a href="${mailto(SITE_CONFIG.INFO_EMAIL)}">${SITE_CONFIG.INFO_EMAIL}</a>`;
export const privacyLink = (): string => `<a href="${routeHref('/privacy')}">Privacy Policy</a>`;
export const termsLink = (): string => `<a href="${routeHref('/terms')}">Terms of Service</a>`;
